export const OPENED_MEDCARDS_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

export const OPENED_MEDCARDS_DEFAULT_PAGE_SIZE = 10;
